import React, { useState, useEffect, useCallback, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import NoProducts from "../../assets/noProducts.png";
import NoFavorites from "../../assets/noFavorites.png";
import NoOrders from "../../assets/noOrders.png";
import NoFound from "../../assets/noFound.png";
import NoAppointments from "../../assets/noAppointments.png";
import NoAppointmentsES from "../../assets/noAppointmentsES.png";
import LoginRequired from "../../assets/requiredSignIn.png";
import LoginRequiredService from "../../assets/requiredSignInService.png";
import LoginRequiredServiceES from "../../assets/requiredSignInServiceES.png";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import { CircularProgress, IconButton } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";
import { Close } from "@mui/icons-material";
import i18n from "../../i18n/config";
import imageCompression from "browser-image-compression";

const useStyles = makeStyles({
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardForm: {
		display: "flex",
	},
	cardGrid: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	placeholderImage: {
		padding: "8px 0px",
		width: 100,
	},
});

export default function Placeholders({ drawerWidth }) {
	const classes = useStyles();
	const [loading, setLoading] = useState(false);
	const [placeholderData, setPlaceholderData] = useState(null);
	const { user } = useContext(UserContext);
	const { t } = useTranslation();
	const service = user.app.appType === "Services";
	const alert = useAlert();
	const [imagesLoading, setImagesLoading] = useState({});

	const openFile = async (
		file,
		key,
		options,
		placeholderData,
		imagesLoading
	) => {
		setImagesLoading({ ...imagesLoading, [key]: true });

		let compressedFile = await imageCompression(file.target.files[0], {
			maxSizeMB: 1,
		});

		const reader = new FileReader();
		reader.onload = function () {
			const saveFile = async (dataURL) => {
				setPlaceholderData({
					...placeholderData,
					[key]: dataURL,
				});
			};
			const dataURL = reader.result;
			if (options) {
				const image = new Image();
				image.src = dataURL;
				image.onload = function () {
					const height = this.height;
					const width = this.width;
					if (options.height !== height || options.width > width) {
						alert.show(options.message, { type: "error" });
					} else {
						saveFile(dataURL);
					}
				};
			} else {
				saveFile(dataURL);
			}
			setImagesLoading({ ...imagesLoading, [key]: false });
		};
		console.log(compressedFile);
		reader.readAsDataURL(compressedFile);
	};

	const getPlaceholderData = async () => {
		setLoading(true);
		try {
			const res = await axios.get(ADMIN_URL + "creators", {
				headers: { authorization: localStorage.getItem("token") },
			});
			setPlaceholderData({
				placeholdersNoProductsTitle: res.data.placeholdersNoProductsTitle,
				placeholdersNoProductsSubtitle: res.data.placeholdersNoProductsSubtitle,
				placeholdersNoProductsButton: res.data.placeholdersNoProductsButton,
				placeholdersNoProductsImage: res.data.placeholdersNoProductsImage,
				placeholdersNoAppointmentsTitle:
					res.data.placeholdersNoAppointmentsTitle,
				placeholdersNoAppointmentsSubtitle:
					res.data.placeholdersNoAppointmentsSubtitle,
				placeholdersNoAppointmentsButton:
					res.data.placeholdersNoAppointmentsButton,
				placeholdersNoAppointmentsImage:
					res.data.placeholdersNoAppointmentsImage,
				placeholdersNoFavoritesTitle: res.data.placeholdersNoFavoritesTitle,
				placeholdersNoFavoritesSubtitle:
					res.data.placeholdersNoFavoritesSubtitle,
				placeholdersNoFavoritesButton: res.data.placeholdersNoFavoritesButton,
				placeholdersNoFavoritesImage: res.data.placeholdersNoFavoritesImage,
				placeholdersNoOrdersTitle: res.data.placeholdersNoOrdersTitle,
				placeholdersNoOrdersSubtitle: res.data.placeholdersNoOrdersSubtitle,
				placeholdersNoOrdersButton: res.data.placeholdersNoOrdersButton,
				placeholdersNoOrdersImage: res.data.placeholdersNoOrdersImage,
				placeholdersLoginRequiredTitle: res.data.placeholdersLoginRequiredTitle,
				placeholdersLoginRequiredSubtitle:
					res.data.placeholdersLoginRequiredSubtitle,
				placeholdersLoginRequiredButton:
					res.data.placeholdersLoginRequiredButton,
				placeholdersLoginRequiredImage: res.data.placeholdersLoginRequiredImage,
				placeholdersNoFoundTitle: res.data.placeholdersNoFoundTitle,
				placeholdersNoFoundSubtitle: res.data.placeholdersNoFoundSubtitle,
				placeholdersNoFoundButton: res.data.placeholdersNoFoundButton,
				placeholdersNoFoundImage: res.data.placeholdersNoFoundImage,
			});
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const savePlaceholderData = useCallback(async () => {
		setLoading(true);
		try {
			await axios.post(ADMIN_URL + "creators", placeholderData, {
				headers: { authorization: localStorage.getItem("token") },
			});
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	}, [placeholderData]);

	useEffect(() => {
		getPlaceholderData();
	}, []);

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />

			<Card variant="outlined">
				<>
					<CardContent>
						<Typography
							sx={{
								fontSize: 14,
								borderBottom: "1px solid #f0f0f0",
								minHeight: "35px",
								marginBottom: "20px",
								marginLeft: "-20px",
								marginRight: "-20px",
								padding: "0px 20px 20px",
							}}
							color="text.secondary"
							gutterBottom
						>
							{t("placeholders.title")}
						</Typography>
						<div className={classes.cardInfo}>
							<Grid
								container
								className={classes.cardForm}
								spacing={8}
								sx={{ alignItems: "flex-start" }}
							>
								{!service && (
									<>
										<Grid
											item
											xs={12}
											sm={6}
											direction="column"
											className={classes.cardGrid}
										>
											<Typography sx={{ marginBottom: 2, opacity: 0.8 }}>
												{t("placeholders.noProducts")}
											</Typography>
											<img
												src={NoProducts}
												alt="iphone"
												className={classes.iphone}
											/>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.titleInput")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={placeholderData?.placeholdersNoProductsTitle}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoProductsTitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.subtitle")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersNoProductsSubtitle
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoProductsSubitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.button")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={placeholderData?.placeholdersNoProductsButton}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoProductsButton: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 2, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-description-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.image")}
												</InputLabel>

												<TextField
													id="app-description-input"
													fullWidth
													variant="outlined"
													readonly
													InputProps={{
														readOnly: true,
														startAdornment: (
															<InputAdornment position="start">
																<Box>
																	<Button
																		size="small"
																		variant="contained"
																		component="label"
																		color="primary"
																		sx={{ height: "24px", fontSize: "10px" }}
																		disabled={[
																			"building",
																			"built",

																			"publishing",
																			"published",
																			"inviting",
																		].find(
																			(status) =>
																				status ===
																				(user.app.appStatuses.length === 0
																					? ""
																					: user.app.appStatuses.length > 0 &&
																					  user.app.appStatuses[0].status)
																		)}
																	>
																		{imagesLoading.placeholdersNoProductsImage ? (
																			<CircularProgress
																				sx={{ color: "white!important" }}
																				size={12}
																			/>
																		) : (
																			t("placeholders.upload")
																		)}
																		<input
																			type="file"
																			accept="image/png, image/jpeg"
																			hidden
																			onChange={(e) => {
																				openFile(
																					e,
																					"placeholdersNoProductsImage",
																					null,
																					placeholderData,
																					imagesLoading
																				);
																			}}
																		/>
																	</Button>
																</Box>
															</InputAdornment>
														),
														endAdornment:
															placeholderData?.placeholdersNoProductsImage && (
																<Box sx={{ position: "relative" }}>
																	<img
																		className={classes.placeholderImage}
																		src={
																			placeholderData?.placeholdersNoProductsImage
																		}
																		alt="logo"
																	/>
																	<IconButton
																		color="inherit"
																		aria-label="delete image"
																		edge="start"
																		onClick={() => {
																			setPlaceholderData({
																				...placeholderData,
																				placeholdersNoProductsImage: null,
																			});
																		}}
																		sx={{
																			position: "absolute",
																			background: "#43BD98",
																			top: 0,
																			right: "-15px",
																			width: "24px",
																			height: "24px",
																			"&:hover": {
																				background: "#43BD98!important",
																			},
																		}}
																	>
																		<Close
																			sx={{ color: "#fff" }}
																			style={{ width: 12, height: 12 }}
																		/>
																	</IconButton>
																</Box>
															),
													}}
												></TextField>
												<Typography
													sx={{
														fontWeight: 500,
														fontSize: 11,
														marginTop: 1,
													}}
												>
													{t("placeholders.changeInApp")}
												</Typography>
											</FormControl>
										</Grid>
										<Grid
											item
											xs={12}
											sm={6}
											direction="column"
											className={classes.cardGrid}
										>
											<Typography sx={{ marginBottom: 2, opacity: 0.8 }}>
												{t("placeholders.noFavorites")}
											</Typography>
											<img
												src={NoFavorites}
												alt="iphone"
												className={classes.iphone}
											/>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.titleInput")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={placeholderData?.placeholdersNoFavoritesTitle}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoFavoritesTitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.subtitle")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersNoFavoritesSubtitle
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoFavoritesSubtitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.button")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={placeholderData?.placeholdersNoFavoritesButton}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoFavoritesButton: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 2, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-description-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.image")}
												</InputLabel>

												<TextField
													id="app-description-input"
													fullWidth
													variant="outlined"
													readonly
													InputProps={{
														readOnly: true,
														startAdornment: (
															<InputAdornment position="start">
																<Box>
																	<Button
																		size="small"
																		variant="contained"
																		component="label"
																		color="primary"
																		sx={{ height: "24px", fontSize: "10px" }}
																		disabled={[
																			"building",
																			"built",

																			"publishing",
																			"published",
																			"inviting",
																		].find(
																			(status) =>
																				status ===
																				(user.app.appStatuses.length === 0
																					? ""
																					: user.app.appStatuses.length > 0 &&
																					  user.app.appStatuses[0].status)
																		)}
																	>
																		{imagesLoading.placeholdersNoFavoritesImage ? (
																			<CircularProgress
																				sx={{ color: "white!important" }}
																				size={12}
																			/>
																		) : (
																			t("placeholders.upload")
																		)}
																		<input
																			type="file"
																			accept="image/png, image/jpeg"
																			hidden
																			onChange={(e) => {
																				openFile(
																					e,
																					"placeholdersNoFavoritesImage",
																					null,
																					placeholderData,
																					imagesLoading
																				);
																			}}
																		/>
																	</Button>
																</Box>
															</InputAdornment>
														),
														endAdornment:
															placeholderData?.placeholdersNoFavoritesImage && (
																<Box sx={{ position: "relative" }}>
																	<img
																		className={classes.placeholderImage}
																		src={
																			placeholderData?.placeholdersNoFavoritesImage
																		}
																		alt="logo"
																	/>
																	<IconButton
																		color="inherit"
																		aria-label="delete image"
																		edge="start"
																		onClick={() => {
																			setPlaceholderData({
																				...placeholderData,
																				placeholdersNoFavoritesImage: null,
																			});
																		}}
																		sx={{
																			position: "absolute",
																			background: "#43BD98",
																			top: 0,
																			right: "-15px",
																			width: "24px",
																			height: "24px",
																			"&:hover": {
																				background: "#43BD98!important",
																			},
																		}}
																	>
																		<Close
																			sx={{ color: "#fff" }}
																			style={{ width: 12, height: 12 }}
																		/>
																	</IconButton>
																</Box>
															),
													}}
												></TextField>
												<Typography
													sx={{
														fontWeight: 500,
														fontSize: 11,
														marginTop: 1,
													}}
												>
													{t("placeholders.changeInApp")}
												</Typography>
											</FormControl>
										</Grid>
										<Grid
											item
											xs={12}
											sm={6}
											direction="column"
											className={classes.cardGrid}
										>
											<Typography sx={{ marginBottom: 2, opacity: 0.8 }}>
												{t("placeholders.noOrders")}
											</Typography>
											<img
												src={NoOrders}
												alt="iphone"
												className={classes.iphone}
											/>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.titleInput")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={placeholderData?.placeholdersNoOrdersTitle}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoOrdersTitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.subtitle")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={placeholderData?.placeholdersNoOrdersSubtitle}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoOrdersSubtitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.button")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={placeholderData?.placeholdersNoOrdersButton}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoOrdersButton: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 2, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-description-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.image")}
												</InputLabel>

												<TextField
													id="app-description-input"
													fullWidth
													variant="outlined"
													readonly
													InputProps={{
														readOnly: true,
														startAdornment: (
															<InputAdornment position="start">
																<Box>
																	<Button
																		size="small"
																		variant="contained"
																		component="label"
																		color="primary"
																		sx={{ height: "24px", fontSize: "10px" }}
																		disabled={[
																			"building",
																			"built",

																			"publishing",
																			"published",
																			"inviting",
																		].find(
																			(status) =>
																				status ===
																				(user.app.appStatuses.length === 0
																					? ""
																					: user.app.appStatuses.length > 0 &&
																					  user.app.appStatuses[0].status)
																		)}
																	>
																		{imagesLoading.placeholdersNoOrdersImage ? (
																			<CircularProgress
																				sx={{ color: "white!important" }}
																				size={12}
																			/>
																		) : (
																			t("placeholders.upload")
																		)}
																		<input
																			type="file"
																			accept="image/png, image/jpeg"
																			hidden
																			onChange={(e) => {
																				openFile(
																					e,
																					"placeholdersNoOrdersImage",
																					null,
																					placeholderData,
																					imagesLoading
																				);
																			}}
																		/>
																	</Button>
																</Box>
															</InputAdornment>
														),
														endAdornment:
															placeholderData?.placeholdersNoOrdersImage && (
																<Box sx={{ position: "relative" }}>
																	<img
																		className={classes.placeholderImage}
																		src={
																			placeholderData?.placeholdersNoOrdersImage
																		}
																		alt="logo"
																	/>
																	<IconButton
																		color="inherit"
																		aria-label="delete image"
																		edge="start"
																		onClick={() => {
																			setPlaceholderData({
																				...placeholderData,
																				placeholdersNoOrdersImage: null,
																			});
																		}}
																		sx={{
																			position: "absolute",
																			background: "#43BD98",
																			top: 0,
																			right: "-15px",
																			width: "24px",
																			height: "24px",
																			"&:hover": {
																				background: "#43BD98!important",
																			},
																		}}
																	>
																		<Close
																			sx={{ color: "#fff" }}
																			style={{ width: 12, height: 12 }}
																		/>
																	</IconButton>
																</Box>
															),
													}}
												></TextField>
												<Typography
													sx={{
														fontWeight: 500,
														fontSize: 11,
														marginTop: 1,
													}}
												>
													{t("placeholders.changeInApp")}
												</Typography>
											</FormControl>
										</Grid>
										<Grid
											item
											xs={12}
											sm={6}
											direction="column"
											className={classes.cardGrid}
										>
											<Typography sx={{ marginBottom: 2, opacity: 0.8 }}>
												{t("placeholders.signInRequired")}
											</Typography>
											<img
												src={LoginRequired}
												alt="iphone"
												className={classes.iphone}
											/>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.titleInput")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersLoginRequiredTitle
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersLoginRequiredTitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.subtitle")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersLoginRequiredSubtitle
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersLoginRequiredSubtitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.button")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersLoginRequiredButton
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersLoginRequiredButton: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 2, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-description-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.image")}
												</InputLabel>

												<TextField
													id="app-description-input"
													fullWidth
													variant="outlined"
													readonly
													InputProps={{
														readOnly: true,
														startAdornment: (
															<InputAdornment position="start">
																<Box>
																	<Button
																		size="small"
																		variant="contained"
																		component="label"
																		color="primary"
																		sx={{ height: "24px", fontSize: "10px" }}
																		disabled={[
																			"building",
																			"built",

																			"publishing",
																			"published",
																			"inviting",
																		].find(
																			(status) =>
																				status ===
																				(user.app.appStatuses.length === 0
																					? ""
																					: user.app.appStatuses.length > 0 &&
																					  user.app.appStatuses[0].status)
																		)}
																	>
																		{imagesLoading.placeholdersLoginRequiredImage ? (
																			<CircularProgress
																				sx={{ color: "white!important" }}
																				size={12}
																			/>
																		) : (
																			t("placeholders.upload")
																		)}
																		<input
																			type="file"
																			accept="image/png, image/jpeg"
																			hidden
																			onChange={(e) => {
																				openFile(
																					e,
																					"placeholdersLoginRequiredImage",
																					null,
																					placeholderData,
																					imagesLoading
																				);
																			}}
																		/>
																	</Button>
																</Box>
															</InputAdornment>
														),
														endAdornment:
															placeholderData?.placeholdersLoginRequiredImage && (
																<Box sx={{ position: "relative" }}>
																	<img
																		className={classes.placeholderImage}
																		src={
																			placeholderData?.placeholdersLoginRequiredImage
																		}
																		alt="logo"
																	/>
																	<IconButton
																		color="inherit"
																		aria-label="delete image"
																		edge="start"
																		onClick={() => {
																			setPlaceholderData({
																				...placeholderData,
																				placeholdersLoginRequiredImage: null,
																			});
																		}}
																		sx={{
																			position: "absolute",
																			background: "#43BD98",
																			top: 0,
																			right: "-15px",
																			width: "24px",
																			height: "24px",
																			"&:hover": {
																				background: "#43BD98!important",
																			},
																		}}
																	>
																		<Close
																			sx={{ color: "#fff" }}
																			style={{ width: 12, height: 12 }}
																		/>
																	</IconButton>
																</Box>
															),
													}}
												></TextField>
												<Typography
													sx={{
														fontWeight: 500,
														fontSize: 11,
														marginTop: 1,
													}}
												>
													{t("placeholders.changeInApp")}
												</Typography>
											</FormControl>
										</Grid>
										<Grid
											item
											xs={12}
											sm={6}
											direction="column"
											className={classes.cardGrid}
										>
											<Typography sx={{ marginBottom: 2, opacity: 0.8 }}>
												{t("placeholders.noSearch")}
											</Typography>
											<img
												src={NoFound}
												alt="iphone"
												className={classes.iphone}
											/>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.titleInput")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={placeholderData?.placeholdersNoFoundTitle}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoFoundTitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.subtitle")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={placeholderData?.placeholdersNoFoundSubtitle}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoFoundSubtitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.button")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={placeholderData?.placeholdersNoFoundButton}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoFoundButton: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 2, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-description-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.image")}
												</InputLabel>

												<TextField
													id="app-description-input"
													fullWidth
													variant="outlined"
													readonly
													InputProps={{
														readOnly: true,
														startAdornment: (
															<InputAdornment position="start">
																<Box>
																	<Button
																		size="small"
																		variant="contained"
																		component="label"
																		color="primary"
																		sx={{ height: "24px", fontSize: "10px" }}
																		disabled={[
																			"building",
																			"built",

																			"publishing",
																			"published",
																			"inviting",
																		].find(
																			(status) =>
																				status ===
																				(user.app.appStatuses.length === 0
																					? ""
																					: user.app.appStatuses.length > 0 &&
																					  user.app.appStatuses[0].status)
																		)}
																	>
																		{imagesLoading.placeholdersNoFoundImage ? (
																			<CircularProgress
																				sx={{ color: "white!important" }}
																				size={12}
																			/>
																		) : (
																			t("placeholders.upload")
																		)}
																		<input
																			type="file"
																			accept="image/png, image/jpeg"
																			hidden
																			onChange={(e) => {
																				openFile(
																					e,
																					"placeholdersNoFoundImage",
																					null,
																					placeholderData,
																					imagesLoading
																				);
																			}}
																		/>
																	</Button>
																</Box>
															</InputAdornment>
														),
														endAdornment:
															placeholderData?.placeholdersNoFoundImage && (
																<Box sx={{ position: "relative" }}>
																	<img
																		className={classes.placeholderImage}
																		src={
																			placeholderData?.placeholdersNoFoundImage
																		}
																		alt="logo"
																	/>
																	<IconButton
																		color="inherit"
																		aria-label="delete image"
																		edge="start"
																		onClick={() => {
																			setPlaceholderData({
																				...placeholderData,
																				placeholdersNoFoundImage: null,
																			});
																		}}
																		sx={{
																			position: "absolute",
																			background: "#43BD98",
																			top: 0,
																			right: "-15px",
																			width: "24px",
																			height: "24px",
																			"&:hover": {
																				background: "#43BD98!important",
																			},
																		}}
																	>
																		<Close
																			sx={{ color: "#fff" }}
																			style={{ width: 12, height: 12 }}
																		/>
																	</IconButton>
																</Box>
															),
													}}
												></TextField>
												<Typography
													sx={{
														fontWeight: 500,
														fontSize: 11,
														marginTop: 1,
													}}
												>
													{t("placeholders.changeInApp")}
												</Typography>
											</FormControl>
										</Grid>
									</>
								)}
								{service && (
									<>
										<Grid
											item
											xs={12}
											sm={6}
											direction="column"
											className={classes.cardGrid}
										>
											<Typography sx={{ marginBottom: 2, opacity: 0.8 }}>
												{t("placeholders.noAppointments")}
											</Typography>
											<img
												src={
													i18n.language === "es" ||
													i18n.language.includes("es-") ||
													i18n.language.includes("-ES") ||
													i18n.language.includes("es_") ||
													i18n.language.includes("_ES") ||
													i18n.language === "ca" ||
													i18n.language === "eu" ||
													i18n.language === "gl"
														? NoAppointmentsES
														: NoAppointments
												}
												alt="iphone"
												className={classes.iphone}
											/>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.titleInput")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersNoAppointmentsTitle
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoAppointmentsTitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.subtitle")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersNoAppointmentsSubtitle
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoAppointmentsSubtitle:
																e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.button")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersNoAppointmentsButton
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersNoAppointmentsButton: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 2, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-description-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.image")}
												</InputLabel>

												<TextField
													id="app-description-input"
													fullWidth
													variant="outlined"
													readonly
													InputProps={{
														readOnly: true,
														startAdornment: (
															<InputAdornment position="start">
																<Box>
																	<Button
																		size="small"
																		variant="contained"
																		component="label"
																		color="primary"
																		sx={{ height: "24px", fontSize: "10px" }}
																		disabled={[
																			"building",
																			"built",

																			"publishing",
																			"published",
																			"inviting",
																		].find(
																			(status) =>
																				status ===
																				(user.app.appStatuses.length === 0
																					? ""
																					: user.app.appStatuses.length > 0 &&
																					  user.app.appStatuses[0].status)
																		)}
																	>
																		{imagesLoading.placeholdersNoAppointmentsImage ? (
																			<CircularProgress
																				sx={{ color: "white!important" }}
																				size={12}
																			/>
																		) : (
																			t("placeholders.upload")
																		)}
																		<input
																			type="file"
																			accept="image/png, image/jpeg"
																			hidden
																			onChange={(e) => {
																				openFile(
																					e,
																					"placeholdersNoAppointmentsImage",
																					null,
																					placeholderData,
																					imagesLoading
																				);
																			}}
																		/>
																	</Button>
																</Box>
															</InputAdornment>
														),
														endAdornment:
															placeholderData?.placeholdersNoAppointmentsImage && (
																<Box sx={{ position: "relative" }}>
																	<img
																		className={classes.placeholderImage}
																		src={
																			placeholderData?.placeholdersNoAppointmentsImage
																		}
																		alt="logo"
																	/>
																	<IconButton
																		color="inherit"
																		aria-label="delete image"
																		edge="start"
																		onClick={() => {
																			setPlaceholderData({
																				...placeholderData,
																				placeholdersNoAppointmentsImage: null,
																			});
																		}}
																		sx={{
																			position: "absolute",
																			background: "#43BD98",
																			top: 0,
																			right: "-15px",
																			width: "24px",
																			height: "24px",
																			"&:hover": {
																				background: "#43BD98!important",
																			},
																		}}
																	>
																		<Close
																			sx={{ color: "#fff" }}
																			style={{ width: 12, height: 12 }}
																		/>
																	</IconButton>
																</Box>
															),
													}}
												></TextField>
												<Typography
													sx={{
														fontWeight: 500,
														fontSize: 11,
														marginTop: 1,
													}}
												>
													{t("placeholders.changeInApp")}
												</Typography>
											</FormControl>
										</Grid>
										<Grid
											item
											xs={12}
											sm={6}
											direction="column"
											className={classes.cardGrid}
										>
											<Typography sx={{ marginBottom: 2, opacity: 0.8 }}>
												{t("placeholders.signInRequired")}
											</Typography>
											<img
												src={
													i18n.language === "es" ||
													i18n.language.includes("es-") ||
													i18n.language.includes("-ES") ||
													i18n.language.includes("es_") ||
													i18n.language.includes("_ES") ||
													i18n.language === "ca" ||
													i18n.language === "eu" ||
													i18n.language === "gl"
														? LoginRequiredServiceES
														: LoginRequiredService
												}
												alt="iphone"
												className={classes.iphone}
											/>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.titleInput")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersLoginRequiredTitle
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersLoginRequiredTitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 0 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.subtitle")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersLoginRequiredSubtitle
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersLoginRequiredSubtitle: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 4, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-name-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.button")}
												</InputLabel>
												<TextField
													id="app-name-input"
													fullWidth
													variant="outlined"
													value={
														placeholderData?.placeholdersLoginRequiredButton
													}
													onChange={(e) => {
														setPlaceholderData({
															...placeholderData,
															placeholdersLoginRequiredButton: e.target.value,
														});
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											</FormControl>
											<FormControl
												fullWidth
												variant="standard"
												sx={{ marginTop: 2, marginBottom: 2 }}
											>
												<InputLabel
													shrink
													htmlFor="app-description-input"
													sx={{
														marginTop: -2,
														fontWeight: 700,
														textTransform: "uppercase",
														fontSize: 12,
													}}
												>
													{t("placeholders.image")}
												</InputLabel>

												<TextField
													id="app-description-input"
													fullWidth
													variant="outlined"
													readonly
													InputProps={{
														readOnly: true,
														startAdornment: (
															<InputAdornment position="start">
																<Box>
																	<Button
																		size="small"
																		variant="contained"
																		component="label"
																		color="primary"
																		sx={{ height: "24px", fontSize: "10px" }}
																		disabled={[
																			"building",
																			"built",

																			"publishing",
																			"published",
																			"inviting",
																		].find(
																			(status) =>
																				status ===
																				(user.app.appStatuses.length === 0
																					? ""
																					: user.app.appStatuses.length > 0 &&
																					  user.app.appStatuses[0].status)
																		)}
																	>
																		{imagesLoading.placeholdersLoginRequiredImage ? (
																			<CircularProgress
																				sx={{ color: "white!important" }}
																				size={12}
																			/>
																		) : (
																			t("placeholders.upload")
																		)}
																		<input
																			type="file"
																			accept="image/png, image/jpeg"
																			hidden
																			onChange={(e) => {
																				openFile(
																					e,
																					"placeholdersLoginRequiredImage",
																					null,
																					placeholderData,
																					imagesLoading
																				);
																			}}
																		/>
																	</Button>
																</Box>
															</InputAdornment>
														),
														endAdornment:
															placeholderData?.placeholdersLoginRequiredImage && (
																<Box sx={{ position: "relative" }}>
																	<img
																		className={classes.placeholderImage}
																		src={
																			placeholderData?.placeholdersLoginRequiredImage
																		}
																		alt="logo"
																	/>
																	<IconButton
																		color="inherit"
																		aria-label="delete image"
																		edge="start"
																		onClick={() => {
																			setPlaceholderData({
																				...placeholderData,
																				placeholdersLoginRequiredImage: null,
																			});
																		}}
																		sx={{
																			position: "absolute",
																			background: "#43BD98",
																			top: 0,
																			right: "-15px",
																			width: "24px",
																			height: "24px",
																			"&:hover": {
																				background: "#43BD98!important",
																			},
																		}}
																	>
																		<Close
																			sx={{ color: "#fff" }}
																			style={{ width: 12, height: 12 }}
																		/>
																	</IconButton>
																</Box>
															),
													}}
												></TextField>
												<Typography
													sx={{
														fontWeight: 500,
														fontSize: 11,
														marginTop: 1,
													}}
												>
													{t("placeholders.changeInApp")}
												</Typography>
											</FormControl>
										</Grid>
									</>
								)}
							</Grid>
						</div>
					</CardContent>
					{!["inviting", "building", "built", "publishing", "published"].find(
						(status) =>
							status ===
							(user.app.appStatuses.length === 0
								? ""
								: user.app.appStatuses.length > 0 &&
								  user.app.appStatuses[0].status)
					) && (
						<CardActions sx={{ justifyContent: "right" }}>
							<Button
								variant="contained"
								size="small"
								onClick={savePlaceholderData}
								disabled={loading}
							>
								{loading ? <CircularProgress size={12} /> : t("general.save")}
							</Button>
						</CardActions>
					)}
				</>
			</Card>
		</Box>
	);
}
